import React from 'react'

import Timer, {TimerState} from "../../gd/task-timer/timer"
import ControlButtonStandard, {
    ControlButtonType
} from "../buttons/control-button/control-button-standard"
import Task from "../../model2/task/task"
import {ControlButtonSize} from "../buttons/control-button/@types";

type Props = {
    className?      : string

    taskId?         : ID
    task?           : Task

    checkDisabled?  : {(e: React.MouseEvent): boolean} // check if click is allowed (is used in bulk selection check)

    onClose?        : func

    size?           : ControlButtonSize
    showCancel?     : boolean   // if set to false - hide delete timer button used in table cell view
}

type State = {
    over    : boolean
    tick?   : boolean
}

export default class TimerView extends React.Component<Props, State> {

    public timer: Timer | null

    constructor(props: Props) {
        super(props)

        this.timer = gd.taskTimers.getTimer(this.taskId)

        this.state = {
            over: false
        }
    }

    componentDidMount() {
        gd.bus.subscribe('task-timers:tick', this, this.timerTick)
        gd.bus.subscribe('task-timers:updated', this, this.timersUpdate)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    get taskId() {
        return this.props.taskId || this.props.task?.id
    }

    timerTick = (taskId: ID) => {
        if (this.taskId === taskId) {
            this.setState({
                tick: true
            })
        }
    }

    timersUpdate = (data?: {taskIds: ID[]}) => {
        if (this.taskId && data?.taskIds?.includes(this.taskId)) {
            this.timer = gd.taskTimers.getTimer(this.taskId)
            this.forceUpdate()
        }
    }

    toggleTimer = (e: React.MouseEvent) => {
        if (this.props.checkDisabled && this.props.checkDisabled(e)) return

        e.stopPropagation()

        const task = this.timer?.task || this.props.task
        if (!task) return

        gd.taskTimers.toggleTimer(task)
        this.timer = gd.taskTimers.getTimer(this.taskId)
        this.forceUpdate()
    }

    stopTimer = (e: React.MouseEvent) => {
        if (this.props.checkDisabled && this.props.checkDisabled(e)) return

        e.stopPropagation()

        gd.taskTimers.stopTimer(this.taskId)
        this.forceUpdate()
    }

    /*closeTimer = (e: React.MouseEvent) => {
        if (this.props.checkDisabled && this.props.checkDisabled(e)) return

        e.stopPropagation()

        gd.taskTimers.cancelTimer(this.taskId, ()=>{
            gd.taskTray.remove(this.taskId)
            this.forceUpdate()
        })
    }*/

    render() {
        const isPaused = !this.timer?.isActive()
        const time = this.timer?.getTime()

        let timeValue
        if (time) {
            if(isPaused) {
                const seconds = Math.ceil(time/(60 * 1000)) * 60
                timeValue = moment.unix(seconds).utc(false).format('HH:mm')
            } else {
                timeValue = gd.taskTimers.formatTimeLong(time)
            }
        }

        const classes = Classes("task-timer flex-row-left-center", this.props.className)

        const timeClasses = Classes("cur-time m-l-5", {
            'is-paused': this.timer?.state === TimerState.TIMER_PAUSED
        })

        const showStopAndCloseButtons = !!this.timer

        return (
            <div className={classes}>
                {isPaused &&
                    <ControlButtonStandard className    = "timer-button player-theme m-l-5"
                                           type         = {ControlButtonType.TIMER_PLAY}
                                           onClick      = {this.toggleTimer}
                                           size         = {this.props.size}
                    />}

                {!isPaused &&
                    <ControlButtonStandard className    = "timer-button player-theme m-l-5"
                                           type         = {ControlButtonType.TIMER_PAUSE}
                                           onClick      = {this.toggleTimer}
                                           size         = {this.props.size}
                    />}

                {showStopAndCloseButtons &&
                    <>
                        <ControlButtonStandard className    = "timer-button player-theme m-l-5"
                                               type         = {ControlButtonType.TIMER_STOP}
                                               onClick      = {this.stopTimer}
                                               size         = {this.props.size}
                        />

                        {this.props.showCancel!==false &&
                            <ControlButtonStandard className    = "timer-button player-theme m-l-5"
                                                   type         = {ControlButtonType.TIMER_CLOSE}
                                                   onClick      = {this.props.onClose /*|| this.closeTimer*/}
                                                   size         = {this.props.size}
                            />
                        }

                    </>}

                {!!timeValue &&
                    <div className={timeClasses}>{timeValue}</div>
                }
            </div>
        )
    }
}
